import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2","key":"svg-0"}],["path",{"d":"M6 15l1 1","key":"svg-1"}],["path",{"d":"M21 8h-4v8h4","key":"svg-2"}],["path",{"d":"M17 12h2.5","key":"svg-3"}],["path",{"d":"M10 10v4a2 2 0 1 0 4 0m0 -4v-2","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconHttpQueOff = createReactComponent('outline', 'http-que-off', 'HttpQueOff', __iconNode);

export default IconHttpQueOff;